import styles from "./styles.module.css";

export const Loader = ({ isLoading }) => {
  if (isLoading)
    return (
      <div className={styles.loader_wrapper}>
        {/* <p className={styles.loader_text}>Initialzing Scene</p> */}
        <img
          src="tv-loading-glitch.gif"
          alt="Loading"
          className={styles.loader_gif}
        />
        {/* <div className={styles.loader} /> */}
      </div>
    );
  return null;
};
